import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-offic-2",
  "use": "icon-ie-offic-2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-offic-2\">\r\n    <path d=\"M933.875 512A421.875 421.875 0 1 1 90.125 512a421.875 421.875 0 0 1 843.75 0z\" fill=\"#FCA013\" p-id=\"4790\">\r\n    </path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol